import { LabelMapper } from 'types';
import { AppTag } from 'components/atoms';
import { getColorsBySeed } from 'utils/getColorsBySeed';

type TableTagDisplayProps<ValueType extends string> = {
    value: ValueType;
    labelMapper: LabelMapper<ValueType>;
};

export const TableTagDisplay = <ValueType extends string>({
    value,
    labelMapper,
}: TableTagDisplayProps<ValueType>) => {
    const label = labelMapper[value];
    const { mainColor, secondaryColor } =
        value === 'ACTIVE' ? getColorsBySeed('0') : getColorsBySeed(value);

    return (
        <AppTag
            style={{
                color: mainColor,
                backgroundColor: secondaryColor,
            }}
        >
            {label}
        </AppTag>
    );
};
